<template>
  <div>
    <el-checkbox-group @change="handleInteractionFiltersChange" v-model="selectedChannelFilterList">
      <el-checkbox
        v-for="(channel, i) in getChannelsList()"
        :label="getChannelName(channel)"
        :key="i"
      ></el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
const cutJoin = str => `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
const capitalise = str => {
  const strArray = str.split('_');
  return Array.isArray(strArray)
    ? strArray.map(cutJoin).join(' ')
    : `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export default {
  name: 'InteractionsFilter',
  props: {
    profile: {
      type: Object,
      default: () => {},
    },
    interactions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedChannelFilterList: [],
      alternativeChannelNames: {
        tweet: {
          name: 'Twitter',
          key: 'tweet',
        },
        message: {
          name: 'SMS',
          key: 'message',
        },
        sms: { name: 'SMS', key: 'message' },
      },
    };
  },

  methods: {
    getChannelsList() {
      const channelNameKeys = Object.keys(this.interactions).map(ch => capitalise(ch));
      return channelNameKeys;
    },

    getChannelName(channelName) {
      return this.alternativeChannelNames[channelName.toLowerCase()]
        ? this.alternativeChannelNames[channelName.toLowerCase()].name
        : channelName;
    },
    getChannelKey(ch) {
      return this.alternativeChannelNames[ch.toLowerCase()]
        ? this.alternativeChannelNames[ch.toLowerCase()].key
        : ch.toLowerCase();
    },
    handleInteractionFiltersChange(checkedChannelsList) {
      const channelKeys = checkedChannelsList.map(this.getChannelKey);
      this.$emit('onFilterInteractions', channelKeys);
    },
  },
};
</script>



// WEBPACK FOOTER //
// InteractionsFilter.vue?6c5c0b5e